


























import { Component, Prop, Vue } from 'vue-property-decorator';
import Button from '@/components/ext/Button.vue';
import { AppHeading } from '@/uikit';

const DEFALT_ERROR =
  'У нас сбой в работе оборудования, попробуйте отправить отклик позднее!';

@Component({
  components: {
    Button,
    AppHeading,
  },
})
export default class SuccessMessage extends Vue {
  @Prop({ type: Boolean, default: false })
  readonly isError!: boolean;

  @Prop({ type: String, default: '' })
  readonly errorMessage!: string;

  get errorText(): string {
    const { errorMessage } = this;
    return errorMessage.length ? errorMessage : DEFALT_ERROR;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/vacancies/form/components/successmewssage/SuccessMessage.vue